import React from 'react';

import { FlexRow } from '@editor/components/utilities/layouts';
import { Badge } from '@repo/ui/components/Badge';
import { Spacer } from '@repo/ui/components/Spacer';
import { H6 } from '@repo/ui/components/Typography';
import { useNewThemeActive } from '@repo/ui/theming';

import { VariationWrapper, Label, Price, SaveBadge } from './styles';
import { VariationProps } from './types';

/**
 * render a price variation
 */
const Variation: React.FC<VariationProps> = ({
  isActive,
  disabled = false,
  label,
  subLabel,
  price,
  priceSubLabel,
  onClick,
}) => {
  const isNewThemeActive = useNewThemeActive();

  return (
    <VariationWrapper
      disabled={disabled}
      isActive={isActive}
      isNewThemeActive={isNewThemeActive}
      onClick={disabled ? undefined : onClick}
    >
      <FlexRow alignItems="center">
        <Label isActive={isActive}>
          <>
            <b>{label}</b>
          </>
        </Label>
        {!!subLabel && (
          <>
            <Spacer width="8px" />
            {isNewThemeActive ? (
              <Badge size="m" text={subLabel} variant="blue" />
            ) : (
              <SaveBadge>
                <H6>{subLabel}</H6>
              </SaveBadge>
            )}
          </>
        )}
      </FlexRow>
      <Spacer height="4px" />
      <Price isActive={isActive}>
        <b>{price}</b>
        {priceSubLabel && <> {priceSubLabel}</>}
      </Price>
    </VariationWrapper>
  );
};

export default Variation;
